import CustomerForm from '../../../../components/secure/customers/CustomerForm'
import { AutoWidthCenter } from '../../../../components/layout/AutoWidthCenter'
import { Box, Button, Divider, Heading, HStack } from '@chakra-ui/react'
import { history } from '../../../../ApplicationRouter'

export default function CreateCustomer() {
  return (
    <AutoWidthCenter>
      <Box py="5">
        <HStack pb="5" justifyContent="space-between">
          <Heading as="h1">Create customer</Heading>
          <Button onClick={() => history.back()}>Back</Button>
        </HStack>
        <Divider />
        <CustomerForm />
      </Box>
    </AutoWidthCenter>
  );
}